<template>
    <section class="row mt-3 section-contact">
        <div class="container">
            <div class="row">
                <div class="col-12">
                    <div class="row">
                        <h1 class="section-title">Liên hệ</h1>
                    </div>
                </div>
            </div>
            <div class="row mt-3">
                <div class="col-12 text-center">
                    <address>
                        <p>
                            <strong>Địa chỉ:</strong>
                            Tầng 3, Tòa nhà An Phú Plaza, 117-119 Lý Chính Thắng, Phường Võ Thị Sáu, Quận 3, Thành phố Hồ Chí Minh, Việt Nam
                        </p>
                        <p>
                            <strong>Email:</strong> biz@mocgame.vn
                        </p>
                    </address>
                </div>
                <div class="col-12">
                    <iframe allowfullscreen="" aria-hidden="false" frameborder="0" height="450" width="100%" tabindex="0"
                            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3919.476186325604!2d106.6723671152602!3d10.774794062169034!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x31752f20b4d7918b%3A0x1c6bb12e504e42e2!2sCharmington%20La%20Pointe!5e0!3m2!1sen!2s!4v1585553026599!5m2!1sen!2s" style="border:0;">
                    </iframe>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
    export default {
        name: "ContactPageComponent"
    }
</script>

<style scoped>

</style>
